import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="services">
      <section className="banner" data-aos="fade-down">
        <h1>Our Services</h1>
      </section>

      <section className="service" data-aos="fade-up">
        <div className="image" data-aos="zoom-in">
          <img src="/Media/airport-service.jpg" alt="Airport Transfers" />
        </div>
        <div className="text" data-aos="fade-left">
          <div className="title">
            <h1>Airport Transfers</h1>
          </div>
          <div className="disc">
            <p>
              Whether traveling for treatment or returning from a trip, our
              airport transfer service offers reliable pick-up and drop-off with
              assistance for those needing extra care.
            </p>
          </div>
        </div>
      </section>

      <section className="service" data-aos="fade-up">
        <div className="image" data-aos="zoom-in">
          <img src="/Media/medical-service.jpg" alt="Medical Transportation" />
        </div>
        <div className="text" data-aos="fade-left">
          <div className="title">
            <h1>Medical Transportation</h1>
          </div>
          <div className="disc">
            <p>
              We provide safe and comfortable rides to hospitals, clinics, and
              rehabilitation centers. Our drivers are trained to assist patients
              and ensure timely arrivals for medical appointments.
            </p>
          </div>
        </div>
      </section>

      <section className="service" data-aos="fade-up">
        <div className="image" data-aos="zoom-in">
          <img
            src="/Media/door-to-door-service.jpg"
            alt="Door-to-Door Service"
          />
        </div>
        <div className="text" data-aos="fade-left">
          <div className="title">
            <h1>Door-to-Door Service</h1>
          </div>
          <div className="disc">
            <p>
              We come directly to your location and ensure a smooth ride to your
              destination. No need to worry about public transport or arranging
              multiple connections.
            </p>
          </div>
        </div>
      </section>

      <section className="service" data-aos="fade-up">
        <div className="image" data-aos="zoom-in">
          <img
            src="/Media/on-demand-service.jpg"
            alt="Scheduled & On-Demand Rides"
          />
        </div>
        <div className="text" data-aos="fade-left">
          <div className="title">
            <h1>Scheduled & On-Demand Rides</h1>
          </div>
          <div className="disc">
            <p>
              Whether you need recurring transportation or a one-time trip, we
              offer both scheduled and on-demand options to fit your lifestyle
              and care routine.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
